var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{staticClass:"custom-col"},[_c('TestPriceAlert',{attrs:{"price":_vm.price,"showReanalysisAlert":_vm.showReanalysisAlert,"medicare":_vm.medicare},scopedSlots:_vm._u([{key:"funding",fn:function(){return [_vm._t("funding")]},proxy:true}],null,true)})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }